import { useEffect, useState } from "react";

export default function ConsoleLogOverlay() {
	const [logs, setLogs] = useState<string[]>([]);

	useEffect(() => {
		const originalLog = console.log;
		const originalError = console.error;
		const originalWarn = console.warn;

		console.log = function (...args) {
			setLogs((prevLogs) =>
				[...prevLogs, `LOG: ${args.map((arg) => formatArg(arg)).join(" ")}`].slice(-8),
			);
			originalLog.apply(console, args);
		};

		console.error = function (...args) {
			setLogs((prevLogs) =>
				[...prevLogs, `ERROR: ${args.map((arg) => formatArg(arg)).join(" ")}`].slice(-8),
			);
			originalError.apply(console, args);
		};

		console.warn = function (...args) {
			setLogs((prevLogs) =>
				[...prevLogs, `WARN: ${args.map((arg) => formatArg(arg)).join(" ")}`].slice(-8),
			);
			originalWarn.apply(console, args);
		};

		return () => {
			console.log = originalLog;
			console.error = originalError;
			console.warn = originalWarn;
		};
	}, []);

	const formatArg = (arg: any): string => {
		if (arg === null) return "null";
		if (arg === undefined) return "undefined";

		try {
			if (typeof arg === "object") {
				return JSON.stringify(arg, null, 2);
			}
			return String(arg);
		} catch (err) {
			return `[Object] (Cannot display: ${err})`;
		}
	};

	return (
		<div className="absolute z-15 top-0 left-0 w-full h-full pointer-events-none">
			<div className="bg-black text-white opacity-80 p-4">
				<h2 className="text-5xl font-bold">Console Logs</h2>
				<div className="overflow-y-auto max-h-screen">
					<pre className="whitespace-pre-wrap text-3xl">
						{logs.map((log, index) => (
							<div key={index}>{log}</div>
						))}
					</pre>
				</div>
			</div>
		</div>
	);
}
